import { lazy } from "react";

export const BrandsPage = lazy(() => import("../pages/BrandsPage"));
export const CatalogImportBatchPage = lazy(() => import("../pages/CatalogImportBatchPage"));
export const CatalogImportPage = lazy(() => import("../pages/CatalogImportPage"));
export const CategoriesPage = lazy(() => import("../pages/CategoriesPage"));
export const CustomersPage = lazy(() => import("../pages/CustomersPage"));
export const OperationsPage = lazy(() => import("../pages/OperationsPage"));
export const OrdersPage = lazy(() => import("../pages/OrdersPage"));
export const ProductEditorPage = lazy(() => import("../pages/ProductEditorPage"));
export const ProductsPage = lazy(() => import("../pages/ProductsPage"));
export const ProfilePage = lazy(() => import("../pages/ProfilePage"));
export const SettingsPage = lazy(() => import("../pages/SettingsPage"));
export const WorkflowManagementPage = lazy(() => import("../pages/WorkflowManagementPage"));
